var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 6C3.5375 6 3.35938 5.92854 3.21563 5.78563C3.07188 5.64271 3 5.46563 3 5.25438C3 5.04313 3.07188 4.86458 3.21563 4.71875C3.35938 4.57292 3.5375 4.5 3.75 4.5H16.25C16.4625 4.5 16.6406 4.57146 16.7844 4.71437C16.9281 4.85729 17 5.03437 17 5.24562C17 5.45687 16.9281 5.63542 16.7844 5.78125C16.6406 5.92708 16.4625 6 16.25 6H3.75ZM3.75 15.5C3.5375 15.5 3.35938 15.4285 3.21563 15.2856C3.07188 15.1427 3 14.9656 3 14.7544C3 14.5431 3.07188 14.3646 3.21563 14.2188C3.35938 14.0729 3.5375 14 3.75 14H16.25C16.4625 14 16.6406 14.0715 16.7844 14.2144C16.9281 14.3573 17 14.5344 17 14.7456C17 14.9569 16.9281 15.1354 16.7844 15.2812C16.6406 15.4271 16.4625 15.5 16.25 15.5H3.75ZM3.75 10.75C3.5375 10.75 3.35938 10.6785 3.21563 10.5356C3.07188 10.3927 3 10.2156 3 10.0044C3 9.79313 3.07188 9.61458 3.21563 9.46875C3.35938 9.32292 3.5375 9.25 3.75 9.25H16.25C16.4625 9.25 16.6406 9.32146 16.7844 9.46438C16.9281 9.60729 17 9.78438 17 9.99563C17 10.2069 16.9281 10.3854 16.7844 10.5312C16.6406 10.6771 16.4625 10.75 16.25 10.75H3.75Z",
    fill: "#252153"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.1ff298fe71d4bee7c913f53ddb415509.svg";
export { ForwardRef as ReactComponent };